import axios from 'axios'

export const MyPlanApi = { 
    getPlan: (companyGroup) => axios.get(`/web/company-groups/company-group-plan/${companyGroup}`),
    listPlan: (companyGroup) => axios.get(`/web/company-groups/company-group-plan`),
}
